import { actionCreator } from '@ardoq/rxbeach';
import { PayloadShowAppModule } from './types';
import { AssetType } from '@ardoq/api-types';
import { GetContentOptions } from 'appModelStateEdit/legacyTypes';
import { Trackable } from 'tracking/trackPayload';

export const requestShowAppModule = actionCreator<
  Trackable<PayloadShowAppModule>
>('[appContainer] REQUEST_SHOW_APP_MODULE');

export const showAppModule = actionCreator<PayloadShowAppModule>(
  '[appContainer] SHOW_APP_MODULE'
);

export const rejectedNavigation = actionCreator<PayloadShowAppModule>(
  '[appContainer] REJECTED_SHOW_APP_MODULE'
);

export type TogglePresentationEditorPayload = {
  shouldShow: boolean;
};
export const togglePresentationEditor =
  actionCreator<TogglePresentationEditorPayload>(
    '[appContainer] TOGGLE_PRESENTATION_EDITOR'
  );

/** Hides the presentation editor when another side panel opens, keeping an in-progress new presentation. */
export const hidePresentationEditor = actionCreator(
  '[appContainer] HIDE_PRESENTATION_EDITOR'
);

export const openProductboardPortal = actionCreator(
  '[appContainer] OPEN_PRODUCTBOARD_PORTAL'
);

export const showRightPane = actionCreator<GetContentOptions>(
  '[appContainer] SHOW_RIGHT_PANE'
);
export const hideRightPane = actionCreator('[appContainer] HIDE_RIGHT_PANE');

export const openHomeWithFilter = actionCreator<AssetType[]>(
  '[appContainer] OPEN_HOME_WITH_FILTER_REQUESTED'
);

export const recalculateGlobalFieldsRequested = actionCreator(
  '[appContainer] RECALCULATE_GLOBAL_FIELDS_REQUESTED'
);
